export default __webpack_public_path__ + "static/media/download_app.5deb08fe.svg";